





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";
import * as Enumerable from "linq-es5"

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import LayerView from "./layerView/layerView.vue"
import GrabbedLayerView from "./grabbedLayerView/grabbedLayerView.vue"

import { Treenode } from "@/definitions/treenode"

@Component({
  components: {
      LayerView,
      GrabbedLayerView
  }
})
export default class ObjectList extends Vue {

  @Prop()
  private nodes!: Treenode[];

  @Prop()
  private renameId!: number;

  private tree : any[] = [];

  @Prop()
  private isGrabbing!: boolean;
  private grabbedNode!: Treenode;
  @Prop()
  private draggingPosition!: {
      left : 0,
      top : 0
  };


  mounted(){
      this.updateTree();
  }

  @Watch("nodes")
  updateTree(){
      this.tree = []
      this.createTree()
  }
  
  createTree(nodes = this.nodes , hierarchy : number = 0 , isVisible : boolean = true){
      for(var i = 0; i < nodes.length; i++){
          nodes[i].data.hierarchy = hierarchy
          nodes[i].data.isVisible = isVisible
          this.tree.push(nodes[i])
          if(nodes[i].children && nodes[i].children.length > 0){
              this.createTree(nodes[i].children , hierarchy + 1 , nodes[i].isExpanded)
          }
      }
  }

  editTitle(node) {
      this.$emit("editTitle", node)
  }

    decideTitle(node , title){
        this.$emit("decideTitle" , node , title)
    }

    selectSingleNode(node){
        if(node){
            this.$emit("selectNode" , [node])
        }else{
            this.$emit("selectNode" , [])
        }
        
    }

    selectMultipleNodes(node){
        this.selectedNodes = []
        this.setSelectedNodes()
        this.selectedNodes.push(node)
        this.$emit("selectNode" , this.selectedNodes)
    }

    removeSelectedFromNode(nodes = this.nodes){
        for(var i = 0; i < nodes.length; i++){
            nodes[i].isSelected = false
            if(nodes[i].children && nodes[i].children.length > 0){
                this.removeSelectedFromNode(nodes[i].children)
            }
        }
    }

    addSelectedToNode(node , nodes = this.nodes){
        for(var i = 0; i < nodes.length; i++){
            if(nodes[i].data.id == node.data.id){
                nodes[i].isSelected = true
                return;
            }
            if(nodes[i].children && nodes[i].children.length > 0){
                this.addSelectedToNode(node , nodes[i].children)
            }
        }
    }

    selectedNodes! : Treenode[]
    setSelectedNodes(nodes = this.nodes) {
        for(var i = 0; i < nodes.length; i++){
            if(nodes[i].isSelected){
                this.selectedNodes.push(nodes[i])
            }
            if(nodes[i].children && nodes[i].children.length > 0){
                this.setSelectedNodes(nodes[i].children)
            }
        }
    }

    onClickRight(node , event){
        this.$emit("nodecontextmenu" , node , event)
    }

    onGrabNode(treeNode , event){
      this.grabbedNode = treeNode
      this.$emit("onGrabNode" ,event)
  }

  dropAtTheEnd(){
   var tree : any[] = []
        for(var i = 0; i < this.tree.length; i++){
            if(this.tree[i].isSelected || this.tree[i] == this.grabbedNode){
                tree.push(this.tree[i])
            }
        }
        for(var i = 0; i < tree.length; i++){
            this.checkForRelations(tree[i] , this.nodes[this.nodes.length - 1])
        }

    

            if(!this.contradiction && Enumerable.asEnumerable(tree).Where(x => x.data.isLocked == true).ToArray().length == 0){

                this.$emit("onDropObjectTree" , tree ,  { node : this.nodes[this.nodes.length - 1] , placement : "after" }, event)
            }
          

      this.contradiction = false
  }

  onDropObjectTree(position , event){

    //   if(this.grabbedNode != position.node){

        var tree : any[] = []
        for(var i = 0; i < this.tree.length; i++){
            if(this.tree[i].isSelected || this.tree[i] == this.grabbedNode){
                tree.push(this.tree[i])
            }
        }
        for(var i = 0; i < tree.length; i++){
            this.checkForRelations(tree[i] , position.node)
        }

    

            if(!this.contradiction && Enumerable.asEnumerable(tree).Where(x => x.data.isLocked == true).ToArray().length == 0){
                this.$emit("onDropObjectTree" , tree , position, event)
            }
          

      this.contradiction = false

      
  }

  
    contradiction = false
  checkForRelations(grabbedNode : Treenode , dropedNode : Treenode){
      if(grabbedNode == dropedNode){
          this.contradiction = true
      }
      for(var i  = 0; i < grabbedNode.children.length; i++){
          if(grabbedNode.children[i] == dropedNode){
              this.contradiction = true
          }
          if(grabbedNode.children[i].children && grabbedNode.children[i].children.length > 0){
              this.checkForRelations(grabbedNode.children[i] , dropedNode)
          }
      }
  } 

}
